import { render, staticRenderFns } from "./NavItems.vue?vue&type=template&id=6bb284ca&"
import script from "./NavItems.vue?vue&type=script&lang=js&"
export * from "./NavItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports